import React from 'react';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import MbHeader from './mbHeader';
import PcHeader from './pcHeader';
import HomeHeader from './pcHeader/homeHeader';
import Register from './pcHeader/register';
import Login from './pcHeader/login';
import FindPwd from './pcHeader/findpsw';
import { isFromMobile } from '@/utils/location';
import TransferModal from '@/components/transferModal';
import { useStore } from '@/models';

interface Props {
  transparent?: boolean;
}

const Header: React.FC<Props> = ({ transparent }) => {
  const { account, ui } = useStore();
  const { isLogin } = account;
  const location = useLocation();

  // 判断是否在首页
  const isHomePage = location.pathname === '/' || location.pathname === '/home';

  if (isFromMobile()) {
    return null;
  }
  return (
    <div className="app-header">
      {isFromMobile() && <MbHeader />}
      {!isHomePage && <PcHeader transparent={transparent} />}
      {/* 首页时显示新的固定 header */}
      {isHomePage && <HomeHeader transparent={transparent} />}
      {isLogin && <TransferModal />}
      {/* 统一在顶层渲染登录注册弹窗，避免重复 */}
      {ui.showRegister && <Register />}
      {ui.showLogin && <Login />}
      {ui.showFindPwd && <FindPwd />}
    </div>
  );
};

export default observer(Header);
